<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let imgMove;
    let cardmove;
    let scrollicon;
    let arrow;
    let imageScale;
    
    onMount(onStart);
    /**
     */
    function onStart() {
        // initializeGsapAnimation(
        //     main,
        //     imageScale,
        //     [
        //         {scale: 1, duration: 1},
        //         {scale: 0.8, duration: 1},
        //     ],
        //     3,
        // );
        initializeGsapAnimation(
            main,
            imgMove,
            [
                {duration: 1, x: '-155vw'},
                {duration: 1, x: '-155vw'},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            scrollicon,
            [
                {duration: 1, marginTop: '11.215vw'},
                {duration: 1, marginTop: '11.215vw'},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            arrow,
            [
                {duration: 1, bottom: '6vw'},
                {duration: 1, bottom: '6vw'},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            cardmove,
            [
                {duration: 1, x: '0vw'},
                {duration: 1, x: '55vw'},
            ],
            3,
        );
    }

    const card = [
        {
            image: '/images/featuersMobile/Lighting.png',
            number: '01',
            name: 'Lighting',
        },
        {
            image: '/images/featuersMobile/Camera.png',
            number: '02',
            name: 'Camera Control',
        },
        {
            image: '/images/featuersMobile/Terrain.png',
            number: '03',
            name: 'Terrain',
        },
        {
            image: '/images/featuersMobile/Trees.png',
            number: '04',
            name: 'Trees. grass, flora.',
        },
        {
            image: '/images/featuersMobile/House.png',
            number: '05',
            name: 'Houses & Buildings',
        },
        {
            image: '/images/featuersMobile/Roads.png',
            number: '06',
            name: 'Roads',
        },
        {
            image: '/images/featuersMobile/zoomgirl.png',
            number: '07',
            name: 'Humanoid Characters',
        },
        {
            image: '/images/featuersMobile/anim.png',
            number: '08',
            name: 'Animations',
        },
    ];
    $: console.log('imageScale', imageScale);
    $: console.log('imgMove', imgMove);
    
</script>

<div class="featureWrraper" bind:this={main}>
    <div class="imgwrraper" bind:this={imgMove}>
        <img
            src="/images/Background.png"
            alt="borders"
            width="auto"
            height="100%"
        />
    </div>
    <div class="content-wrraper">
        <div class="title">
            <h2>Core Tech</h2>
            <h1>FEATURES</h1>
        </div>
        <div class="scroll">
            <div class="featureCardWrraper" bind:this={cardmove}>
                {#each card as data}
                    <div class="card">
                        <div class="cardInnerWrraper">
                            <div class="imageWrraper" bind:this={imageScale}>
                                <img
                                    src={data.image}
                                    alt="features"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                            <div class="text">
                                <div>
                                    <p>{data.name}</p>
                                </div>
                                <div>
                                    <p>{data.number}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
        <div class="scroll_div" bind:this={scrollicon}>
            <p class="scrollText">drag</p>
            <svg
                width="18.224vw"
                height="0.741vw"
                viewBox="0 0 72 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="img"
            >
                <path
                    d="M71.3536 4.35355C71.5488 4.15829 71.5488 3.84171 71.3536 3.64645L68.1716 0.464466C67.9763 0.269204 67.6597 0.269204 67.4645 0.464466C67.2692 0.659728 67.2692 0.976311 67.4645 1.17157L70.2929 4L67.4645 6.82843C67.2692 7.02369 67.2692 7.34027 67.4645 7.53553C67.6597 7.7308 67.9763 7.7308 68.1716 7.53553L71.3536 4.35355ZM0 4.5H71V3.5H0V4.5Z"
                    fill="black"
                />
            </svg>
        </div>
    </div>
    <div class="arrow" bind:this={arrow}>
        <p>></p>
    </div>
</div>

<style>
        .arrow {
            z-index: 2;
            position: absolute;
            bottom: 70vw;
        display: flex;
        justify-content: center;
        align-items: center;    
        height: 2.336vw;
        width: 100%;
    }
    .arrow p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 500;
        font-size: 7.009vw;
        line-height: 8.79vw;
        letter-spacing: 0.06em;
        color: #000000;
        transform: rotate(90deg);
    
    }
    .content-wrraper {
        top: 14.5vw;
        z-index: 1;
        width: 100vw;
        position: absolute;
    }
    .imgwrraper {
        width: 100vw;
        height: max(216.355vw, 100vh);
        transform: translate(-55vw, 0vw);
        
    }
    .featureWrraper {
        width: 100vw;
        overflow: hidden;
        font-style: normal;
        position: relative;
        font-family: "Orbitron";
    }
    .title {
        margin: 30vw 0 25vw;
    }
    .title h2 {
        margin: 0;
        color: #000000;
        font-weight: 900;
        margin-left: 6vw;
        line-height: 100%;
        font-size: 7.009vw;
        text-transform: uppercase;
    }
    .title h1 {
        left: 6vw;
        margin: 0;
        color: rgba(255, 255, 255, 0);
        position: absolute;
        font-weight: 900;
        line-height: 100%;
        text-align: center;
        font-size: 14.019vw;
        text-transform: uppercase;
        -webkit-text-stroke: 0.234vw black;
    }
    .scroll {
        overflow-x: scroll;
    }
    .scroll::-webkit-scrollbar {
        display: none;
    }
    .featureCardWrraper {
        gap: 5vw;
        display: flex;
        padding: 0 5vw;
        width: fit-content;
        align-items: center;
        transform: translate(-185vw, 0vw);
    }
    .card {
        margin: auto;
        padding: 4vw;
        width: 71.729vw;
        box-sizing: border-box;
        background-color: #f9f9f9;
        height: max(89.019vw, 41.145vh);
        box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.25);
    }
    .cardInnerWrraper {
        width: 62.617vw;
        margin: auto;
        height: max(70.561vw, 32.613vh);
    }
    .imageWrraper {
        /* transform: scale(0.8); */
        /* scale: 0.8; */
        width: 62.383vw;
        height: max(70.561vw, 32.613vh);
    }
    .text {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .scroll_div {
        position: absolute;
        display: flex;
        align-items: center;
        margin-left: 46.495vw;
        margin-top: -25vw;
    }
    .scroll_div .scrollText {
        font-size: 2.336vw;
        font-weight: 400;
        line-height:3.037vw;
        letter-spacing: 0.06em;
        color: black;
        text-transform: capitalize;
        margin: 0;
    }
    .scroll_div .img {
        margin-left: 8.178vw;
        width: 18.224vw;
        height: 3vw;
    }
</style>
